import { WrapWithABContext } from '../components/wrappers/WrapWithABContext';
import { WrapWithAemConfigurationContext } from '../components/wrappers/WrapWithAemConfigurationContext';
import { WrapWithQueryContext } from '../components/wrappers/WrapWithQueryContext';
import { WrapWithReduxStoreContext } from '../components/wrappers/WrapWithReduxStoreContext';
export const generateRenderingObject = (renderData, translationObject) => ({
    ...renderData,
    translation: {
        language: translationObject.initialLanguage,
        translationResources: translationObject.initialI18nStore,
    },
});
export const generateWrapperComponents = (renderData, store) => {
    const possibleWrappers = [];
    possibleWrappers.push({
        wrapper: WrapWithAemConfigurationContext,
        additionalWrapperArguments: {
            aemConfigurationValue: renderData.context.aemConfiguration,
        },
    });
    possibleWrappers.push({
        wrapper: WrapWithABContext,
        additionalWrapperArguments: {
            abConfigurationValue: renderData.context.abConfiguration,
        },
    });
    possibleWrappers.push({
        wrapper: WrapWithQueryContext,
        additionalWrapperArguments: {
            dehydratedState: renderData.queryClientState,
        },
    });
    if (store) {
        possibleWrappers.push({
            wrapper: WrapWithReduxStoreContext,
            additionalWrapperArguments: { store },
        });
    }
    return possibleWrappers;
};
